define([
	"dojo/_base/declare",
	"csi/action/_ImageBrowseMixin",
	"csi/action/Controller"
], function(declare,_ImageBrowseMixin,Controller) {

	return declare([Controller,_ImageBrowseMixin], {
		_getImageContext: function() {
			// summary: no context when managing images site-wide
			return null;
		}
	});
});